import { createContext, useContext, useState, useCallback } from 'react';

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const [clientId, setClientIdState] = useState(() => {
    return sessionStorage.getItem('activeClientId') || null;
  });
  const [clientName, setClientNameState] = useState(() => {
    return sessionStorage.getItem('activeClientName') || null;
  });

  const setClientId = useCallback((id) => {
    if (id) {
      sessionStorage.setItem('activeClientId', id);
    } else {
      sessionStorage.removeItem('activeClientId');
      sessionStorage.removeItem('activeClientName');
      setClientNameState(null);
    }
    setClientIdState(id);
  }, []);

  const setClientName = useCallback((name) => {
    if (name) {
      sessionStorage.setItem('activeClientName', name);
    } else {
      sessionStorage.removeItem('activeClientName');
    }
    setClientNameState(name);
  }, []);

  return (
    <ClientContext.Provider value={{
      clientId,
      setClientId,
      clientName,
      setClientName,
    }}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const ctx = useContext(ClientContext);
  if (!ctx) throw new Error('useClient must be used within ClientProvider');
  return ctx;
}
